import React from 'react';
import PropTypes from 'prop-types';
import { ItemListProvider } from './ItemContext';
import Container from './Container';

const ItemList = ({ metaOverrideSet }) => {
  return (
    <ItemListProvider>
      <Container metaOverrideSet={metaOverrideSet} />
    </ItemListProvider>
  );
};

ItemList.propTypes = {
  metaOverrideSet: PropTypes.object,
};

ItemList.defaultProps = {
  metaOverrideSet: null,
};
export default ItemList;
